import { backendApi } from '../../config'

export type Request = {
  firstName: string
  lastName: string
  corporateName?: string
  documentType: 'CNPJ' | 'CPF'
  email: string
  document: string
  password: string
  phone: string
  description?: string
  image?: File
  gender?: string
  socialNetworks?: Array<{
    type: string
    url: string
  }>
  categories?: string[]
  address: {
    city: string
    state: string
    zipCode: string
    country: string
    district: string
    number: number
    street: string,
    complement: string,
  }
  customField?: object
  partnerInviteToken?: string
}

export const registerCreatorService = async (data: Request) => {
  const formData = new FormData()

  // Adicionar campos básicos
  Object.entries(data).forEach(([key, value]) => {
    if (key !== 'address' && key !== 'socialNetworks' && key !== 'image' && key !== 'categories' && value !== undefined) {
      formData.append(key, String(value))
    }
  })

  // Adicionar endereço
  formData.append('address', JSON.stringify(data.address))

  // Adicionar redes sociais se existirem
  if (data.socialNetworks) {
    formData.append('socialNetworks', JSON.stringify(data.socialNetworks))
  }

  // Adicionar categorias se existirem
  if (data.categories) {
    formData.append('categories', JSON.stringify(data.categories))
  }

  // Adicionar imagem de perfil se existir
  if (data.image) {
    formData.append('image', data.image)
  }

  const response = await backendApi.post('api/creators', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return response.data
}
